var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrust = function SvgIconTrust(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.25 6.836H8.75c-.73 0-1.429.283-1.945.787A2.66 2.66 0 0 0 6 9.523v9.406c0 8.856 4.386 14.222 8.066 17.165 3.963 3.168 7.906 4.245 8.078 4.288.237.063.486.063.722 0 .172-.043 4.11-1.12 8.078-4.288C34.614 33.151 39 27.784 39 18.93V9.523c0-.713-.29-1.396-.806-1.9a2.78 2.78 0 0 0-1.944-.787m0 12.093c0 6.227-2.348 11.281-6.978 15.02a22.4 22.4 0 0 1-6.772 3.73 22.2 22.2 0 0 1-6.69-3.664c-4.685-3.746-7.06-8.82-7.06-15.086V9.523h27.5z",
    opacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#icon-trust_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.314 18.426a1.058 1.058 0 0 0-1.941 0c-1.095 2.483-1.517 2.905-4 4a1.058 1.058 0 0 0 0 1.942c2.483 1.093 2.905 1.515 4 3.999.374.85 1.567.85 1.941 0 1.094-2.482 1.515-2.904 4-3.999.85-.374.85-1.567 0-1.941-2.483-1.094-2.904-1.516-4-4.001M30.807 13.454a.662.662 0 0 0-1.176 0c-.408.78-.7 1.071-1.48 1.48a.662.662 0 0 0 0 1.176c.78.408 1.072.7 1.48 1.48a.662.662 0 0 0 1.176 0c.409-.78.7-1.072 1.48-1.48a.662.662 0 0 0 0-1.176c-.78-.409-1.072-.7-1.48-1.48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-trust_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.5 12.24h21v21h-21z"
  })))));
};
export default SvgIconTrust;